module.exports = "pegasus_template/assets/tech/small/7.jpg";